/// <amd-module name="Wit/WorkItemTFVCLinks/Components/ChangesetLinkForm" />
import { usePageContext } from "VSS/Platform/Layout";
import { ArtifactsUpdatedCallback } from "Wit/WorkItemLinksRegistration/IRegisteredLinkTypeService";
import * as React from "react";
import { changesetToDisplayData } from "../TFVCLinkUtils";
import { ChangesetPicker } from "./ChangesetPicker";

interface IChangesetLinkFormProps {
    onArtifactsUpdated: ArtifactsUpdatedCallback;
}

export function ChangesetLinkForm({ onArtifactsUpdated }: IChangesetLinkFormProps) {
    const pageContext = usePageContext();
    return (
        <ChangesetPicker
            onChangesetChanged={(changeset, path) => {
                if (!changeset) {
                    return;
                }
                onArtifactsUpdated([changesetToDisplayData(pageContext, changeset, undefined, path)]);
            }}
        />
    );
}
